import React from 'react';
import { FavouriteAPISubscriber } from '@atlassian/jira-favourite-api-controller/src';

import { FavouriteChangeConsumer } from '../index';

import ImperativeApi from './view';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ImperativeApiWrapper(_props: Record<any, any>) {
	return (
		<FavouriteChangeConsumer>
			{(favouriteChangeContext) => (
				<FavouriteAPISubscriber>
					{(__, actions) => (
						<ImperativeApi
							items={favouriteChangeContext.items}
							changeFavourite={favouriteChangeContext.changeFavourite}
							// @ts-expect-error - TS2322 - Type 'BoundActions<State, Actions>' is not assignable to type 'Actions'.
							callbackRegistry={actions}
						/>
					)}
				</FavouriteAPISubscriber>
			)}
		</FavouriteChangeConsumer>
	);
}
